import { useState } from 'react';
import { toast } from 'react-toastify';

import axios from 'axios';
import config from '../../config';

import TextField from '@mui/material/TextField';

const CreateAmenityBookingForm = ({
    onRequestCreated,
    onClose,
    prefilledData = {}
}) => {
    const [formData, setFormData] = useState({
        amenity: prefilledData.amenity || null,
        bookedBy: prefilledData.bookedBy,
        bookingDate: prefilledData.bookingDate || '',
        startTime: prefilledData.startTime || '',
        endTime: prefilledData.endTime || '',
        status: 'pending',
        notes: '',
        role: prefilledData.role
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        if (!formData.amenity || !formData.bookingDate || !formData.startTime || !formData.endTime) {
            setError('Missing booking details. Please try again.');
            return;
        }

        try {

            console.log('Submitting booking:', formData);

            const response = await axios.post(
                `${config.API_URL}/v2/amenity/booking`,
                {
                    amenity: formData.amenity._id,
                    bookedBy: formData.bookedBy,
                    bookingDate: formData.bookingDate,
                    startTime: formData.startTime,
                    endTime: formData.endTime,
                    status: formData.status,
                    notes: formData.notes,
                    role: formData.role
                },
                {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}`, 'Content-Type': 'application/json' }
                }
            );

            if (response.status === 200 || response.status === 201) {
                onRequestCreated(response.data);
                toast.success('Amenity booking created successfully!');
                onClose();
            }
        } catch (error) {
            setError(`Error creating the booking. Please try again.`);
            toast.error(`Failed to create the amenity booking.`);
            console.error(error);
        }
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-popup" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>
                <h2 className="text-2xl text-black">Complete Amenity Booking</h2>

                {/* Booking summary */}
                <div className="bg-blue-50 p-4 rounded-lg mb-4 border border-blue-200">
                    <h3 className="font-semibold text-blue-800 mb-2">Booking Summary</h3>
                    <div className="text-sm text-blue-700 space-y-1">
                        <p><strong>Amenity:</strong> {formData.amenity?.name || ''}</p>
                        <p><strong>Date:</strong> {formData.bookingDate}</p>
                        <p><strong>Time:</strong> {formData.startTime} - {formData.endTime}</p>
                    </div>
                </div>

                {/* Notes */}
                <TextField
                    label="Additional Notes (Optional)"
                    name="notes"
                    multiline
                    fullWidth
                    rows={3}
                    value={formData.notes}
                    onChange={handleChange}
                    sx={{ marginBottom: '1rem' }}
                    placeholder="Any special requests or additional information..."
                />

                <button type="button" className="button" onClick={handleSubmit}>
                    Confirm Booking
                </button>

                {error && <div className="error-message">{error}</div>}
            </div>
        </div>
    );
};

export default CreateAmenityBookingForm;

